<p-table
  [value]="issuerDetails"
  [paginator]="issuerDetails.length > 0"
  [rows]="5"
  [tableStyle]="{ 'min-width': '50rem' }"
  selectionMode="single"
  dataKey="asReportedIssuerId"
>
  <ng-template #header>
    <tr>
      <th>A R. ID</th>
      <th>Issuer Name</th>
      <th>CIK</th>
      <th>EIN</th>
      <th>SIC</th>
      <th>File No</th>
      <th>Year End</th>
      <th>STATE OF INCORPORATION</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr [pSelectableRow]="issuer">
      <td>{{ issuer.asReportedIssuerId || "N/A" }}</td>
      <td>{{ issuer.asReportedIssuerName || "N/A" }}</td>
      <td>{{ issuer.asReportedCik || "N/A" }}</td>
      <td>{{ issuer.asReportedEin || "N/A" }}</td>
      <td>{{ issuer.asReportedSic || "N/A" }}</td>
      <td>{{ issuer.asReportedFileNumber || "N/A" }}</td>
      <td>{{ issuer.asReportedFiscalYearEnd || "N/A" }}</td>
      <td>{{ issuer.asReportedStateOfIncorporation || "N/A" }}</td>
      <td>
        <div>
          <button
            (click)="onRevertIssuer(issuer)"
            class="bg-red-600 cursor-pointer text-white py-1 px-3 rounded hover:bg-red-700 transition-colors"
          >
            Revert
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="noRecord">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>

<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
